module.exports = __webpack_public_path__ + "static/media/close.b19094c1.svg";